import * as actions from "../actionTypes"

const initialState = {
  value: 100, // % of original size
}

export default function carouselScale(state = initialState, action) {
  switch (action.type) {
    case actions.SET_CAROUSEL_SCALE: {
      return {
        ...state,
        value: action.payload.value,
      }
    }

    default:
      return state
  }
}
